import { UrlParamsType } from '@appTypes/urlParamsType';
import { CarModelType } from '@appTypes/carModelType';

// Comma-joined list of percent-encoded values; the comma separator stays unencoded
// because the API parses on it.
const encodeValues = (values: string[]) => values.map(encodeURIComponent).join(',');

const createAPIQuery = (
  params?: UrlParamsType,
  additionalFilters?: UrlParamsType['filter'],
  ids?: CarModelType['slug'][] | CarModelType['id'][],
) => {
  let queries = '';

  if (params && typeof params.query !== 'undefined') {
    queries += `&query=${encodeURIComponent(params.query)}`;
  }

  if (params && typeof params.filter !== 'undefined') {
    Object.entries(params.filter).forEach(([key, values]) => {
      if (typeof values !== 'undefined') {
        queries += `&${encodeURIComponent(key)}=${encodeValues(values)}`;
      }
    });
  }

  if (params && typeof params.sortBy !== 'undefined') {
    queries += `&sortBy=${encodeURIComponent(params.sortBy)}`;
  }

  if (typeof additionalFilters !== 'undefined') {
    Object.entries(additionalFilters).forEach(([key, values]) => {
      if (typeof values !== 'undefined') {
        queries += `&${encodeURIComponent(key)}=${encodeValues(values)}`;
      }
    });
  }
  if (typeof ids !== 'undefined') {
    queries += `&ids=${encodeValues(ids as string[])}`;
  }

  return queries.slice(1);
};

export const createQueryBySlug = (slugs: CarModelType['slug'][]) => `slugs=${slugs.map(encodeURIComponent).join(',')}`;

export default createAPIQuery;
